export enum TapType {
  ON = "ON",
  OFF = "OFF",
}
